<!-- @format -->

<ng-container *transloco="let t">
  @if (searchService.searchParameters$ | async; as searchParameters) {
    @let minFullTextQueryLength = searchService.minFullTextQueryLength;
    @if (isSearchValid(searchParameters, minFullTextQueryLength)) {
      <fudis-hr />
      <ng-content />
    }
  }
</ng-container>
